<table [class.table-primary]="showPrimaryColor" class="table table-bordered" cellspacing="0" width="100%">
    <thead *ngIf="showHeadings">
    <tr>
<!--        <th></th>-->
        <!-- <th> <input type="checkbox" [checked]="isAllCheckBoxChecked()" (change)="checkAllCheckBox($event)"></th> -->
        <th class="th-sm" style="text-align: left">Account Number
        </th>
        <th class="th-sm" style="text-align: left">Account Name
        </th>
        <th class="th-sm" style="text-align: left">Trading Name
        </th>
        <th class="th-sm" style="text-align: left">Registration Number
        </th>
        <th class="th-sm" style="text-align: left">Lead User </th>
        <th>Carrier Type Description </th>
        <th>Account Balance</th>
        <th>Account Status</th>
    </tr>
    </thead>
    <tbody *ngIf="listAccounts.length">
    <tr *ngFor="let acc of listAccounts; let index = index">
        <!-- ([ngModel])="terms" [checked]="terms=='1'" [disabled]="isadminuser" (click)="ckeckTerms($event)" -->
        <!-- [(ngModel)]="listAccounts[i].checked" -->
<!--        <td><input type="checkbox" value="{{acc.id}}" [ngModel]="selectedIndex === index"-->
<!--                   (change)="CheckedCarrier($event,acc.id,acc,index)"></td>-->
        <td>{{acc.account_number}}</td>
        <td>{{acc.account_name}}</td>
        <td>{{acc.trading_name }}</td>
        <td>{{acc.reg_number }}</td>
        <td>{{acc.link_person}}</td>
        <td>{{acc.carrier_type_description}}</td>
        <td style="text-align: right">{{acc.account_balance ? (acc.account_balance | currencyFormat) : 'R 0.00'}}
        </td>
        <td>{{acc.status }}</td>
    </tr>
    </tbody>
</table>
